import * as React from "react";
import { IDataCenter } from "../../vm";
import { getAllDataCenters } from "../../services/datacenter/DatacenterService";
import { Loading } from "../../services/Loading";
import { Text } from "office-ui-fabric-react";
import { useHistory } from "react-router-dom";
import DataCenterCard from "./DataCenterCard";
import PageTitle from "../common/PageTitle";
import { ToastContext } from "../common/ToastProvider";
import { ReactComponent as DatacenterIcon } from "../../images/data-center.svg";

export interface DatacentersListMainProps {}

const DatacentersListMain: React.FC<DatacentersListMainProps> = () => {
  // state
  const [state, setState] = React.useState({
    dataCenters: [],
    isLoading: false,
  } as {
    dataCenters: IDataCenter[];
    isLoading: boolean;
  });

  // customs hooks
  const history = useHistory();
  const { showToast } = React.useContext(ToastContext);

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      await getDataCenters();
    };
    asyncFunc();
  }, []);

  const getDataCenters = async () => {
    setState({ ...state, isLoading: true });
    let result = await getAllDataCenters();
    if (result && result?.success) {
      setState({
        ...state,
        isLoading: false,
        dataCenters: result.data,
      });
    } else {
      showToast(
        result?.message || "Error while getting Datacenter list",
        "error"
      );
      setState({
        ...state,
        isLoading: false,
      });
    }
  };
  const viewDataCenter = (data: IDataCenter) => {
    history.push(`/datacenters/${data._id}`);
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading isModeless={true} />}
      <div>
        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <PageTitle
                title="Data Center"
                description="List of all the data centers available"
                icon={DatacenterIcon}
              />
            </div>
          </div>
        </div>
        <br />
        <div className="ms-Grid">
          <div className="ms-Grid-row">
            {state.dataCenters.length > 0 ? (
              state.dataCenters.map((dataCenter, index) => (
                <div
                  key={index}
                  className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl3 ms-xxl2"
                >
                  <DataCenterCard
                    dataCenter={dataCenter}
                    viewDataCenter={viewDataCenter}
                  />
                </div>
              ))
            ) : (
              <div className="ms-Grid-col text-center ms-sm12 ms-md12 ms-lg12 ms-xl12">
                <Text variant="large">No Data Centers Found</Text>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DatacentersListMain;
